module.exports = __webpack_public_path__ + "static/media/guide-step-2.0ddabbe4.png";